import CreatePage from './create';
export default CreatePage;
